import { MAP_OPTIONS } from './constants';
/**
 * Initializes a Google Map instance with the specified options and callbacks.
 *
 * @param {object} options - The options for the map.
 * @param {number} options.zoom - The initial zoom level of the map.
 * @param {object} options.center - The initial center coordinates of the map.
 * @param {object} options.maps - The Google Maps API object.
 * @param {Function} options.initialIdleCallback - The callback to be called when the map becomes idle.
 * @param {Function} options.tilesLoadedCallback - The callback to be called when the map tiles are loaded.
 * @param {Function} options.onDragStart - The callback to be called when the user starts dragging the map.
 * @param {Function} options.onDragEnd - The callback to be called when the user stops dragging the map.
 * @param {Function} options.onZoomChanged - The callback to be called when the user zooms in or out of the map.
 * @param {HTMLElement} options.container - The HTML element that will contain the map.
 * @returns {object} The Google Map instance.
 */
export const initializeMap = ({ googleMapsId, zoom, center, maps, initialIdleCallback, idle, tilesLoadedCallback, onDragStart, onDragEnd, onZoomChanged, container, onMapClick, }) => {
    const map = new maps.Map(container, {
        ...MAP_OPTIONS,
        zoom,
        center,
        mapTypeId: maps.MapTypeId.ROADMAP,
        mapId: googleMapsId,
    });
    maps.event.addListenerOnce(map, 'idle', initialIdleCallback);
    maps.event.addListenerOnce(map, 'tilesloaded', () => {
        maps.event.addListener(map, 'dragstart', onDragStart);
        maps.event.addListener(map, 'dragend', onDragEnd);
        maps.event.addListener(map, 'zoom_changed', onZoomChanged);
        maps.event.addListener(map, 'idle', idle);
        tilesLoadedCallback();
    });
    maps.event.addListener(map, 'click', onMapClick);
    return map;
};
